import vipToastMobileConfig from '@src/js/common/ark-extensions/dc-components/vip-toast-mobile/component-config';
import vipToastConfig from '@src/js/common/ark-extensions/dc-components/vip-toast/component-config';
import ArkLoader from '@src/js/common/ark-extensions';
import { browser } from '../../slide/infrastructure/module/independent/agent/common';

type IShowToast = ({ errorCode }: { errorCode: number }) => boolean;

interface IVipToastExtension {
    show: IShowToast,
}

export default class VipToastService {
    private static instance: VipToastService;
    public static getInstance(): InstanceType<typeof VipToastService> {
        if (!this.instance) {
            this.instance = new VipToastService();
        }

        return this.instance;
    }
    private vipToastExtension: IVipToastExtension;

    public async init(): Promise<IVipToastExtension> {
        if (!this.vipToastExtension) {
            await this.load();
        }

        return this.vipToastExtension;
    }
    /**
     * 展示会员阻断弹窗，参见 DC 组件 docs-component-vip-toast
     */
    public async showVipToast({ errorCode }: { errorCode: number }): Promise<boolean> {
        const vipToast = await this.init();
        return vipToast.show({ errorCode });
    }

    private async load(): Promise<void> {
        const isMobileDevice = browser.isMobile || browser.isIPad;
        const configName = isMobileDevice ? vipToastMobileConfig.name : vipToastConfig.name;
        this.vipToastExtension = await ArkLoader.extensionService.getExtension(configName);
    }
}
